import { render, staticRenderFns } from "./bigTitle.vue?vue&type=template&id=43ef74cd&scoped=true"
import script from "./bigTitle.vue?vue&type=script&lang=js"
export * from "./bigTitle.vue?vue&type=script&lang=js"
import style0 from "./bigTitle.vue?vue&type=style&index=0&id=43ef74cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef74cd",
  null
  
)

export default component.exports